import { EventBus } from "../../../eventbus";

export default {
  props: {
    title: String,
    id: String,
    steps: Array,
    defaultShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: this.defaultShow,
      activeStepId: "",
      lastStepId: "",
      overlaydata: {},
    };
  },
  methods: {
    closeOverlay() {
      this.show = false;
    },
  },
  created() {
    EventBus.$on("openOverlayPage", (data) => {
      if (this.id === data.id) {
        this.show = true;

        //set init step if present
        if (this.steps && this.steps[0]) {
          this.activeStepId = this.steps[0].id;
        }

        //data
        this.overlaydata = data;
      } else {
        this.show = false;
      }
    });

    EventBus.$on("updateOverlayPageStep", (data) => {
      if (this.id === data.id) {
        this.activeStepId = data.activeStepId;

        //set laststep
        if (this.steps) {
          this.steps.forEach((step) => {
            if (step.id === this.activeStepId) {
              this.lastStepId = step.lastStepId;
            }
          });
        }
      }
    });

    EventBus.$on("closeOverlayPage", (data) => {
      if (this.id === data.id) {
        this.show = false;
        this.activeStepId = "";
        this.lastStepId = "";
      }
    });
  },
};
